import { RiAdminLine } from 'react-icons/ri';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const Admins = {
  id: 'admins',
  title: '',
  type: 'group',
  children: [
    {
      id: 'admins-management',
      title: 'Admins',
      type: 'item',
      url: '/admins',
      icon: RiAdminLine,
      allowedRoles: ['superAdmin'],
      breadcrumbs: false
    }
  ]
};

export default Admins;
